import { OnInit, OnDestroy } from '@angular/core';
import { Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
var LoginComponent = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    function LoginComponent(_fuseConfigService, _formBuilder, _router, _authService, _translate, _translationLoader) {
        this._fuseConfigService = _fuseConfigService;
        this._formBuilder = _formBuilder;
        this._router = _router;
        this._authService = _authService;
        this._translate = _translate;
        this._translationLoader = _translationLoader;
        this.lang = 'sr';
        this.badLoginMsg = '';
        this.hide = true;
        // Configure the layout
        this._fuseConfigService.config = {
            theme: {
                layout: {
                    navbar: {
                        hidden: true
                    },
                    toolbar: {
                        hidden: true
                    },
                    footer: {
                        hidden: true
                    },
                    sidepanel: {
                        hidden: true
                    }
                }
            }
        };
        if (document.getElementById('social-intents-tab-chat') !== null) {
            document.getElementById('social-intents-tab-chat').remove();
        }
        if (document.getElementById('siWidget-chat') !== null) {
            document.getElementById('siWidget-chat').remove();
        }
        if (document.getElementById('sibutton') !== null) {
            document.getElementById('sibutton').remove();
        }
        if (document.getElementById('socialintents-chat') !== null) {
            document.getElementById('socialintents-chat').remove();
        }
        if (document.getElementById('chat') !== null) {
            document.getElementById('chat').remove();
        }
        this._unsubscribeAll = new Subject();
    }
    Object.defineProperty(LoginComponent.prototype, "emailInput", {
        get: function () { return this.loginForm.get('email'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginComponent.prototype, "passwordInput", {
        get: function () { return this.loginForm.get('password'); },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.getTranslations = function () {
        var _this = this;
        this._translationLoader.getLastLang()
            .then(function (response) {
            _this.lang = response['code'];
            _this._translationLoader.getTranslations(_this.lang, '5');
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
        }, function (err) {
        });
    };
    LoginComponent.prototype.signInWithGoogle = function () {
        this.serverBadLogin = false;
        this._authService.authenticationError = '';
        this._authService.authenticateSocial('google');
    };
    LoginComponent.prototype.signInWithFB = function () {
        this.serverBadLogin = false;
        this._authService.authenticationError = '';
        this._authService.authenticateSocial('facebook');
    };
    LoginComponent.prototype.onSubmit = function () {
        this.serverBadLogin = false;
        this._authService.authenticationError = '';
        this._authService.authenticate(this.loginForm.value.emailaksljf, this.loginForm.value.passwordlkjkl);
        // this._authService.authenticationComplete
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe(data => {
        //         console.log(data);
        //         if (data) {
        //             this._fuseConfigService.config = {
        //                 fuse: {
        //                     layout: {
        //                         navbar: {
        //                             hidden: false
        //                         },
        //                         toolbar: {
        //                             hidden: false
        //                         }
        //                     }
        //                 }
        //             };
        //             this._router.navigate(['/users-management']);
        //         } else {
        //             this.serverBadLogin = true;
        //         }
        //     });
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    /**
     * On init
     */
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this._authService.isAuthenticated()) {
            this._authService.logout();
        }
        this.loginForm = this._formBuilder.group({
            emailaksljf: ['', [Validators.required, Validators.email]],
            passwordlkjkl: ['', Validators.required]
        });
        this._authService.authenticationComplete
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (data) {
            console.log(data);
            if (data === true) {
                _this._authService.updatePreferredLanguage(_this.lang);
                _this._router.navigate(['/welcome']);
            }
            else {
                _this.serverBadLogin = true;
                _this._authService.errorCode === 503 ? _this.badLoginMsg = 'Temporary Rejected!' : _this.badLoginMsg = 'Invalid account!';
                console.log(_this._authService.errorCode);
            }
        });
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (value) {
            _this.getTranslations();
        });
        this.getTranslations();
    };
    LoginComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    };
    return LoginComponent;
}());
export { LoginComponent };
